import { c as _c } from "react/compiler-runtime";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { useEffect } from "react";
import { authClient } from "@/clients/authClient";
import { useLoginModal } from "@/lib/hooks/useLoginModal";
import { jsx as _jsx } from "react/jsx-runtime";
export const Route = createFileRoute("/_app/mitt-konto")({
  component: AccountLayout
});
function AccountLayout() {
  const $ = _c(8);
  const {
    data: session,
    isPending
  } = authClient.useSession();
  const loginModal = useLoginModal();
  let t0;
  let t1;
  if ($[0] !== isPending || $[1] !== loginModal || $[2] !== session) {
    t0 = () => {
      if (!isPending && !session) {
        loginModal.onOpen();
      }
    };
    t1 = [isPending, session, loginModal];
    $[0] = isPending;
    $[1] = loginModal;
    $[2] = session;
    $[3] = t0;
    $[4] = t1;
  } else {
    t0 = $[3];
    t1 = $[4];
  }
  useEffect(t0, t1);
  if (isPending) {
    let t2;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /*#__PURE__*/_jsx("div", {
        className: "flex min-h-[60vh] items-center justify-center",
        children: /*#__PURE__*/_jsx("div", {
          className: "h-8 w-8 animate-spin rounded-full border-4 border-brand/30 border-t-brand"
        })
      });
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  if (!session) {
    let t2;
    if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = /*#__PURE__*/_jsx("div", {
        className: "flex min-h-[60vh] items-center justify-center",
        children: /*#__PURE__*/_jsx("p", {
          className: "text-gray-500",
          children: "Du m\xE5ste vara inloggad."
        })
      });
      $[6] = t2;
    } else {
      t2 = $[6];
    }
    return t2;
  }
  let t2;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = /*#__PURE__*/_jsx("div", {
      className: "flex min-h-[60vh] items-center justify-center py-8",
      children: /*#__PURE__*/_jsx(Outlet, {})
    });
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}